import { Seo } from '@/components/Seo';
import { ContentPage } from '@/components/PublicLayout';
import { useLang, useT } from '@/i18n/LanguageContext';
import { newsletterContent } from '@/i18n/content/newsletter';
import { NewsletterForm } from '@/components/NewsletterForm';
import { pathFor } from '@/i18n/routes';

export default function Newsletter() {
  const lang = useLang();
  const t = useT(newsletterContent);

  return (
    <>
      <Seo title={t.seoTitle} description={t.seoDescription} path={pathFor('nieuwsbrief', lang)} />
      <ContentPage title={t.title} intro={t.intro}>
        <div className="space-y-8">
          {t.body.map((p, i) => (
            <p key={i} className="leading-relaxed text-sitefg/75">
              {p}
            </p>
          ))}
          <div className="pt-4">
            <NewsletterForm source="page" />
          </div>
        </div>
      </ContentPage>
    </>
  );
}
